/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Crm_Send_EmptyInputs */

const en_error_crm_send_empty = /** @type {(inputs: Error_Crm_Send_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nobody of this audience can receive the email.`)
};

/**
* | output |
* | --- |
* | "Nobody of this audience can receive the email." |
*
* @param {Error_Crm_Send_EmptyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_crm_send_empty = /** @type {((inputs?: Error_Crm_Send_EmptyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Crm_Send_EmptyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_crm_send_empty(inputs)
});